module.exports = __webpack_public_path__ + "static/img/dubai.7aab216.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/dubai.jpg
// module id = ik46
// module chunks = 1